declare namespace $ {

	type $bog_music_nav_item__label_bog_music_nav_1 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_music_nav_item['label'] >
	>
	type $bog_music_nav_item__active_bog_music_nav_2 = $mol_type_enforce<
		ReturnType< $bog_music_nav['search_active'] >
		,
		ReturnType< $bog_music_nav_item['active'] >
	>
	type $bog_music_nav_item__Icon_bog_music_nav_3 = $mol_type_enforce<
		ReturnType< $bog_music_nav['Search_icon'] >
		,
		ReturnType< $bog_music_nav_item['Icon'] >
	>
	type $bog_music_nav_item__click_bog_music_nav_4 = $mol_type_enforce<
		ReturnType< $bog_music_nav['search_click'] >
		,
		ReturnType< $bog_music_nav_item['click'] >
	>
	type $bog_music_nav_item__label_bog_music_nav_5 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_music_nav_item['label'] >
	>
	type $bog_music_nav_item__active_bog_music_nav_6 = $mol_type_enforce<
		ReturnType< $bog_music_nav['music_active'] >
		,
		ReturnType< $bog_music_nav_item['active'] >
	>
	type $bog_music_nav_item__Icon_bog_music_nav_7 = $mol_type_enforce<
		ReturnType< $bog_music_nav['Music_icon'] >
		,
		ReturnType< $bog_music_nav_item['Icon'] >
	>
	type $bog_music_nav_item__click_bog_music_nav_8 = $mol_type_enforce<
		ReturnType< $bog_music_nav['music_click'] >
		,
		ReturnType< $bog_music_nav_item['click'] >
	>
	type $bog_music_nav_item__label_bog_music_nav_9 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_music_nav_item['label'] >
	>
	type $bog_music_nav_item__active_bog_music_nav_10 = $mol_type_enforce<
		ReturnType< $bog_music_nav['account_active'] >
		,
		ReturnType< $bog_music_nav_item['active'] >
	>
	type $bog_music_nav_item__Icon_bog_music_nav_11 = $mol_type_enforce<
		ReturnType< $bog_music_nav['Account_icon'] >
		,
		ReturnType< $bog_music_nav_item['Icon'] >
	>
	type $bog_music_nav_item__click_bog_music_nav_12 = $mol_type_enforce<
		ReturnType< $bog_music_nav['account_click'] >
		,
		ReturnType< $bog_music_nav_item['click'] >
	>
	type $bog_music_nav_item__label_bog_music_nav_13 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_music_nav_item['label'] >
	>
	type $bog_music_nav_item__active_bog_music_nav_14 = $mol_type_enforce<
		ReturnType< $bog_music_nav['logs_active'] >
		,
		ReturnType< $bog_music_nav_item['active'] >
	>
	type $bog_music_nav_item__Icon_bog_music_nav_15 = $mol_type_enforce<
		ReturnType< $bog_music_nav['Logs_icon'] >
		,
		ReturnType< $bog_music_nav_item['Icon'] >
	>
	type $bog_music_nav_item__click_bog_music_nav_16 = $mol_type_enforce<
		ReturnType< $bog_music_nav['logs_click'] >
		,
		ReturnType< $bog_music_nav_item['click'] >
	>
	export class $bog_music_nav extends $mol_view {
		search_active( ): string
		Search_icon( ): $mol_icon_magnify
		search_click( next?: any ): any
		Tab_search( ): $bog_music_nav_item
		music_active( ): string
		Music_icon( ): $mol_icon_playlist_music
		music_click( next?: any ): any
		Tab_music( ): $bog_music_nav_item
		account_active( ): string
		Account_icon( ): $mol_icon_account_circle
		account_click( next?: any ): any
		Tab_account( ): $bog_music_nav_item
		logs_active( ): string
		Logs_icon( ): $mol_icon_text_box_outline
		logs_click( next?: any ): any
		Tab_logs( ): $bog_music_nav_item
		section( next?: string ): string
		dev( ): boolean
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=nav.view.tree.d.ts.map